import React, { useState, useEffect } from "react";
import { DateRangePicker, Stack } from "rsuite";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import swal from "sweetalert2";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { StetheAttendanceExportActions } from "../../../Redux/Slice";

const CalenderPopup = (props) => {
  const { show, setShow, EditID, counts } = props;
  const Swal = require("sweetalert2");
  const dispatch = useDispatch();
  const [selectedDates, setSelectedDates] = useState();
  var today = new Date();
  var prioiDate = new Date(new Date().setDate(today.getDate() - 30));
  // console.log(String(today) );
  var it = String(today);
  var gt = String(prioiDate);
  // console.log(it, gt);
  const [Choicesformat, setformat] = useState("");
  const [range, setrange] = useState([gt, it]);
  const [withoutData, setwithoutData] = useState(true);
  const [Dob, setDob] = useState(["D.O.J", "D.O.B", "Designation"]);

  useEffect(() => {
    // Log the array directly
    console.log(Dob, "withoutData");
    // Log the array as a JSON string
    console.log(JSON.stringify(Dob), "as JSON string");
  }, [Dob]);

  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
    const lastDateOfMonth = new Date(currentYear, currentMonth, 0);

    const startDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(firstDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;

    return {
      startDatemon,
      endDatemon,
    };
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();

  const [data, setdata] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: false,
    base_type: "day",
  });

  const Options = [
    {
      id: 1,
      value: "day",
      label: "DAY",
    },
    {
      id: 2,
      value: "time",
      label: "TIME",
    },
  ];

  const HandleChanges = (e) => {
    //    console.log(e.target.value, "sdfsdgfweifi");

    setdata({ ...data, base_type: e.target.value });
  };

  const [datestae, setdatest] = useState(false);
  const formattedDates =
    selectedDates != null &&
    selectedDates.map((date) => {
      const isoString = date.toISOString();
      return isoString.substring(0, 10);
    });

  const handleDateChange = (e) => {
    if (e != null) {
      setdatest(true);
      setSelectedDates(e);

      e.forEach((newValue) => {
        const tzoffset = new Date().getTimezoneOffset() * 60000;
        const localISOTime = new Date(newValue - tzoffset)
          .toISOString()
          .slice(0, -1);
        // handle the start and end dates here
      });
    }

    setformat("");
  };

  //----Handle----Date=-----Changes---
  const handlechangedate = (value, d) => {
    // console.log(value , d , "vlues");
    if (value != null) {
      setrange((oldArray) => [...oldArray, d.slice(0, 10)]);
    }
    console.log(range, "range");
  };
  const HanldeExport = (e) => {
    Swal.fire({
      title: `Export Attendance`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Export",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: () => {
        const payloads = {
          export_type: "",
          client_id: "",
          //   data: values.data,

          user_id: "",
          // data: values.data,
          // startDate: startDate.toISOString(), // Convert to ISO format or modify as needed
          // endDate: endDate.toISOString(),
        };
        return dispatch(StetheAttendanceExportActions(payloads));
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Exported!", "Attendance exported successfully.", "success");
      }
    });
  };

  const attendanceexport = (e, statement, values) => {
    var x = 0;
    if (data.from_date == undefined && data.to_date == undefined) {
      setformat("*Date is required");
      x = 1;
    }
    // if(data.from_date != "" )
    if (x == 0) {
      Swal.fire({
        title: `Are you sure, do you want to export the attendance  ${
          statement ? "based on this month to end of the  month" : ""
        }?`,
        text: "You won't be able to revert this",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f26639",
        cancelButtonColor: "#F69338",
        confirmButtonText: "Yes, Export it!",
      }).then((result) => {
        if (result.isConfirmed) {
          const payloads = {
            export_type: values,
            client_id: EditID,
            user_id: "",
            data: data,
            Dob: JSON.stringify(Dob),
            // Dob:JSON.stringify(["D.O.J", "D.O.B" ]),
            withoutData: withoutData,
          };
          dispatch(StetheAttendanceExportActions(payloads));
          console.log(payloads, "payloads");
          setShow(false)
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
      });
    }
  };

  const attendanceexportEmp = (e, statement, values) => {
    console.log(values, statement, e, "auysfdasdasdyasdlas");
    var x = 0;
    if (data.from_date == undefined && data.to_date == undefined) {
      setformat("*Date is required");
      x = 1;
    }

    if (x == 0) {
      Swal.fire({
        title: `Are you sure, do you want to export the attendance  ${
          statement ? "based on this month to  end of the  month" : ""
        }?`,
        text: "You won't be able to revert this",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f26639",
        cancelButtonColor: "#F69338",
        confirmButtonText: "Yes, Export it!",
      }).then((result) => {
        if (result.isConfirmed) {
          const payloads = {
            export_type: "employee",
            client_id: "",
            //   user_id: values.user_id,
            user_id: EditID,
            data: data,
            Dob: JSON.stringify(Dob),
            withoutData: withoutData,
            //   data: values.data,
          };
          dispatch(StetheAttendanceExportActions(payloads));
          setShow(false);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
      });
    }
  };

  useEffect(() => {
    if (datestae) {
      setdata({
        ...data,
        from_date: formattedDates[0],
        to_date: formattedDates[1],
        range: true,
      });
    }
  }, [selectedDates]);

  const cleaningrange = () => {
    //setrange([gt,it]);
    setSelectedDates([]);
    setdata({
      ...data,
      from_date: "",
      to_date: "",
      range: true,
    });
  };


  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '358.344px', 'important');
      rsAnimFade.style.setProperty('top', '485.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }



  return (
    <>
      <div className="Shift ">
        <div className="Shift ShiftCreatePopup">
          <div
            // className={`  ${stateDisplay ? " POPUP" : "outerPOPUP"}`}
            className="  BeforeSHIFTPopUp"
          >
            <div className=" BodyShiftContent " style={{ width: "35%" }}>
              <div className="card">
                <div className="card-body cards ">
                  <div className="UserPoup">
                    <div className="BeforForms" style={{ width: "100%" }}>
                      <div className="Form" style={{ width: "100%" }}>
                        <div className="ModalHeader" style={{ width: "100%" }}>
                          {counts == 1
                            ? " Export Attendance Sheet based on branch"
                            : " Export Attendance Sheet based on employee"}
                          <div
                            className="CloseIcon"
                            onClick={(e) => setShow(false)}
                          >
                            <CloseOutlinedIcon />
                          </div>
                        </div>
                        <div className="Modal-Body">
                          <div className="row">
                            <div className="col-9">
                              <label style={{ marginLeft: "12px" }}>
                                <input
                                  type="checkbox"
                                  value={withoutData}
                                  onChange={(e) => {
                                    if (withoutData) {
                                      setDob([]);
                                    } else {
                                      setDob(["D.O.J", "D.O.B", "Designation"]);
                                    }

                                    setwithoutData(!withoutData);
                                  }}
                                />

                                <span style={{ marginLeft: "12px" }}>
                                  {withoutData
                                    ? "without (DOB , DOJ , Designation) Sheet will be Export"
                                    : "with (DOB, DOJ, Designation) Sheet will be Export"}
                                </span>
                              </label>
                            </div>
                            <div className="col-3"></div>

                            <div className="col-6">
                              <DateRangePicker
                                className="Dateranger"
                                //   style={{ width: 270, padding: 10 }}
                                style={{
                                  width: "100%",
                                  padding: 5,
                                  marginTop: "5px",
                                }} // Adjust the width and padding as needed
                                placeholder="From-To"
                                onChange={handleDateChange}
                                onOpen={() => {
                                  openMe()
                                }}
                             onClose={() => {
                                CloseDateRange()
                                   }}
                                showHeader={false}
                                size="lg"
                                value={selectedDates}
                                onClean={(e) => cleaningrange(e)}
                              />

                              <p style={{ color: "red", marginLeft: "8px" }}>
                                {Choicesformat}
                              </p>
                            </div>

                            <div className="col-6">
                              <select
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  marginTop: "10px",
                                }}
                                class="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                name="marital_status"
                                onChange={(e) => {
                                  HandleChanges(e);
                                }}
                              >
                                {Options.map((item) => (
                                  <option
                                    value={item.value}
                                    // selected={
                                    //   data.marital_status != undefined
                                    //     ? data.marital_status.toLowerCase() ==
                                    //       item.value.toLowerCase()
                                    //     : null
                                    // }
                                  >
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div
                          className="UserButtons"
                          style={{
                            marginTop: "30px",
                            letterSpacing: "1.2px",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px ",
                            alignItems: "center",
                          }}
                        >
                          <button
                            class="btn"
                            type="submit"
                            style={{
                              background: "#F58738",
                              color: "white",
                              padding: "10px",
                              borderRadius: "10px",
                            }}
                            // onClick={(e) => {
                            //   HanldeExport(e);
                            // }}

                            onClick={(e) => {
                              e.stopPropagation();

                              if (counts == 1) {
                                if (
                                  startDatemon == data.from_date &&
                                  endDatemon == data.to_date
                                ) {
                                  attendanceexport(e, true, "client");
                                } else {
                                  attendanceexport(e, false, "client");
                                }
                              } else {
                                const payloads = {
                                  export_type: "employee",
                                  client_id: "",
                                  user_id: EditID,
                                  data: data,
                                };
                                if (
                                  startDatemon == data.from_date &&
                                  endDatemon == data.to_date
                                ) {
                                  attendanceexportEmp(e, true, payloads);
                                } else {
                                  attendanceexportEmp(e, false, payloads);
                                }
                              }
                            }}
                          >
                            Attendance Sheet Export
                          </button>

                          <button
                            class=" CancelBtn ButtonCSS"
                            style={{ background: "#ef4d39", color: "white" }}
                            //   onClick={(e) => {
                            //     handleClosepop(e);
                            //   }}
                            onClick={(e) => setShow(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CalenderPopup;
